import React from 'react';
import ReactQueryProvider from './ReactQueryProvider';
import MantineProvider from './MantineProvider';
import AppNameProvider from './AppProvider';

interface ContextsProps {
  children: React.ReactNode;
}

const Contexts = ({ children }: ContextsProps) => {
  return (
    <MantineProvider>
      <ReactQueryProvider>
        <AppNameProvider>{children}</AppNameProvider>
      </ReactQueryProvider>
    </MantineProvider>
  );
};

export default Contexts;
